<template>
  <div
    :id="item.key"
    class="o-text-element mb-7"
  >
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <div v-html="item.rteText" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TextElement',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
